import { numInput, parseNum, type Site, t } from '@procumi/shared';
import { useState } from 'react';
import type { Toast } from '../hooks/useToast';
import { api, errMsg } from '../lib/api';
import { Dialog } from './Dialog';

export function SiteDialog({
  site,
  toast,
  onSaved,
  onClose,
}: {
  /** lipsă la adăugare, prezent la editare */
  site?: Site;
  toast: Toast;
  onSaved: (site: Site) => void;
  onClose: () => void;
}) {
  const editing = site != null;
  const [name, setName] = useState(site?.name ?? '');
  const [locality, setLocality] = useState(site?.locality ?? '');
  const [address, setAddress] = useState(site?.address ?? '');
  const [client, setClient] = useState(site?.client ?? '');
  const [budget, setBudget] = useState(site?.budget == null ? '' : numInput(site.budget));
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (name.trim().length < 2) {
      toast(t('Completează numele șantierului'));
      return;
    }
    const b = budget.trim() ? parseNum(budget) : null;
    if (budget.trim() && (b == null || b <= 0)) {
      toast(t('Bugetul trebuie să fie o sumă în lei, mai mare decât zero'));
      return;
    }
    setBusy(true);
    try {
      const fields = {
        name: name.trim(),
        locality: locality.trim(),
        address: address.trim(),
        client: client.trim(),
        budget: b,
      };
      const saved = editing ? await api.updateSite(site.id, fields) : await api.createSite(fields);
      onSaved(saved);
      onClose();
      toast(editing ? t('Șantier actualizat') : t('Șantier adăugat'));
    } catch (e) {
      toast(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog onClose={onClose}>
      <div className="dlg-h">
        <div>
          <h2>{editing ? t('Editează {0}', site.name) : t('Șantier nou')}</h2>
          <p className="hint">
            {t(
              'Tot ce se cere și se cumpără ține de un șantier. Adresa ajunge în mailul către furnizori, ca loc de livrare.',
            )}
          </p>
        </div>
      </div>
      <div className="dlg-b">
        <div className="row">
          <label className="f" style={{ gridColumn: '1/-1' }} htmlFor="site-name">
            {t('Denumire')}
            <input
              id="site-name"
              className="inp"
              autoFocus
              value={name}
              placeholder={t('ex. Creșă Pucioasa')}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <label className="f" htmlFor="site-locality">
            {t('Localitate')}
            <input
              id="site-locality"
              className="inp"
              value={locality}
              placeholder={t('ex. Pucioasa, DB')}
              onChange={(e) => setLocality(e.target.value)}
            />
          </label>
          <label className="f" htmlFor="site-client">
            {t('Beneficiar (opțional)')}
            <input
              id="site-client"
              className="inp"
              value={client}
              placeholder={t('ex. Primăria Pucioasa')}
              onChange={(e) => setClient(e.target.value)}
            />
          </label>
          <label className="f" style={{ gridColumn: '1/-1' }} htmlFor="site-address">
            {t('Adresă de livrare (opțional)')}
            <input
              id="site-address"
              className="inp"
              value={address}
              placeholder={t('strada și numărul, dacă diferă de localitate')}
              onChange={(e) => setAddress(e.target.value)}
            />
          </label>
          <label className="f" htmlFor="site-budget">
            {t('Buget achiziții (opțional)')}
            <input
              id="site-budget"
              className="inp"
              inputMode="decimal"
              value={budget}
              placeholder={t('lei fără TVA')}
              onChange={(e) => setBudget(e.target.value)}
            />
            <span className="hint" style={{ margin: 0 }}>
              {t('Pe panou vezi cât s-a cumpărat și cât e angajat față de el.')}
            </span>
          </label>
        </div>
      </div>
      <div className="dlg-f">
        <button className="btn" onClick={onClose}>
          {t('Anulează')}
        </button>
        <button className="btn primary" disabled={busy} onClick={() => void save()}>
          {editing ? t('Salvează') : t('Adaugă șantier')}
        </button>
      </div>
    </Dialog>
  );
}
